'use client'

import EnterViewAnimate from '@/components/enterView/animate'
import { map } from 'lodash-es'
import CaseStudiesCard from './card'
import { useDataViewContext } from './context'

export default function DataViewContent() {
  const { data } = useDataViewContext()

  return (
    <section className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-5 px-4 lg:px-7.5 py-7.5 lg:py-12.5 gap-x-7.5 gap-y-7.5 lg:gap-y-12.5'>
      {map(data, (item, i) => (
        <EnterViewAnimate animate='animate__fadeInUp' key={i}>
          <CaseStudiesCard data={item} />
        </EnterViewAnimate>
      ))}
    </section>
  )
}
